<template>
  <div>
    <!-- Header -->
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header">
      <h4 class="title-tab-experience-manager">HOME SCREEN MANAGER</h4>
    </div>

    <div class="widget-content">
      <!-- Banner -->
      <div class="company-banner">
        <img
          :src="url_banner || require('@/assets/img/banner-dummy.png')"
          alt="company-banner"
        >
        <div class="banner-container" />

        <!-- Button change banner -->
        <button @click="showPopupChangeBanner">
          <i class="fa fa-pencil-square-o" />
          Change Banner
        </button>
      </div>

      <!-- Widget Content -->
      <div class="content-officeless-home">
        <!-- Profile -->
        <div
          v-if="profile_data"
          class="profile-box"
        >
          <div class="profile-images inline--block">
            <img :src="profile_data.photo_url || require('@/assets/img/profile-dummy.png')">
          </div>
          <div class="inline--block">
            <div
              v-if="organigramName"
              class="profile-name"
            >
              {{ `${profile_data.first_name} ${profile_data.last_name}` }}
            </div>
            {{ organigramName }}
          </div>
        </div>

        <!-- My Application -->
        <div class="my-application">
          <div class="title">MY APPLICATIONS</div>

          <div class="appliaction-list">
            <div
              v-for="i in 8"
              :key="i"
              class="application"
            />
          </div>
        </div>

        <!-- Widget List -->
        <b-row>
          <b-col cols="6">
            <j-widget-list
              :data-widget-list="dataWidgetDetailLeft"
              :position="1"
            />
          </b-col>

          <b-col cols="6">
            <j-widget-list
              :data-widget-list="dataWidgetDetailRight"
              :position="2"
            />
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- Upload Banner -->
    <b-modal
      ref="modalBanner"
      class="mod-form modal-banner-widget"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">Change Banner</div>
      <div
        v-if="showModalBanner"
        class="dropbox-oos d-flex flex-column justify-content-center align-items-center">
        <input
          type="file"
          class="input-file"
          @change="handleFileUpload($event, true)">
        <img :src="require('@/assets/form-data/file-dropbox.png')">
        <div class="label-dropbox">Drop your document here, or <span>browse</span></div>
      </div>
      <div class="label-required-upload">Maximum File Size: 5 MB</div>
      <div class="label-required-upload">Support: JPG, PNG</div>
      <div class="label-required-upload">Size: 1920 x 350px</div>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray"
              @click="closePopupBanner">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="modalCrop"
      class="mod-form modal-crop-banner"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div
        v-if="showModalCrop && fileUrl">
        <j-cropping-image
          :url="fileUrl"
          :name-file="fileName"
          title="Banner Cropping"
          @save-banner="saveBanner"
          @close-modal="closePopupCrop"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable max-len */
import { mapState, mapActions } from 'vuex';
import jWidgetList from '@/views/widget/jWidgetList';
import jCroppingImage from '@/components/cropping/jCroppingImage';
import jApiEmployee from '@/services/jApiEmployee';
import jMixWidgetBanner from '@/mixins/jMixWidgetBanner';

export default {
  components: {
    jWidgetList,
    jCroppingImage,
  },

  mixins: [jMixWidgetBanner],

  data() {
    return {
      showModalBanner: false,
      showModalCrop: false,
      url_banner: '',
      organigramName: '',
      dataWidgetDetailLeft: [],
      dataWidgetDetailRight: [],
      icon_options: [],
      itemsBreadcrumb: [{ text: 'WIDGET', to: '/widget' }],
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['company_banner', 'list_widget_master', 'list_widget_detail', 'side_menu']),
    ...mapState('jStoreLogin', ['profile_data']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
  },
  watch: {
    profile_data(val) {
      if (val) {
        this.getPositionEmployee();
      }
    },

    company_banner(val) {
      if (val) this.url_banner = val.url_banner;
    },

    list_widget_detail(data) {
      // Separate position
      const leftList = data.filter(el => el.position === 1);
      const rightList = data.filter(el => el.position === 2);

      // Add mode_edit
      const leftEditList = leftList.map(el => ({ ...el, mode_edit: false }));
      const rightEditList = rightList.map(el => ({ ...el, mode_edit: false }));

      // Sort by order
      this.dataWidgetDetailLeft = leftEditList.sort((a, b) => a.order - b.order);
      this.dataWidgetDetailRight = rightEditList.sort((a, b) => a.order - b.order);
    },

    fileUrl(val) {
      if (val) {
        this.showPopupCrop();
      }
    },
  },
  created() {
    this.getCompanyBanner();
    this.getPositionEmployee();
    this.getListWidget();
    this.getListIcon();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem', 'toggleSuccess']),
    ...mapActions('jStoreApplication', ['actionGetCompanyBanner', 'actionSetCompanyBanner', 'getListWidgetMaster', 'getListComponent', 'getListWidgetDetail', 'deleteWidget', 'actionGetListIcons', 'actionUpdatePage', 'actionGetSideMenuList']),

    getPositionEmployee() {
      if (this.profile_data) {
        jApiEmployee.employeePosition({ user_company_id: this.profile_data.user_company_id }).then((res) => {
          if (res.data.length > 0) {
            this.organigramName = res.data[0].name;
          }
        });
      }
    },

    async getListIcon() {
      const params = {
        page: 1,
        limit: 100,
        column: 'id',
        sort: 'desc',
        query: '',
        query_type: '',
      };
      const res2 = await this.actionGetListIcons(params);
      if (!res2.error) {
        this.icon_options = [];
        res2.data.forEach((lab) => {
          this.icon_options.push({
            name: lab.name,
            id: lab.id,
            is_delete: false,
          });
        });
      }
    },

    getCompanyBanner() {
      const params = {
        page: 1,
        limit: 1,
        column: 'id',
        sort: 'asc',
      };
      this.actionGetCompanyBanner({ params });
    },

    saveBanner() {
      this.getCompanyBanner();
      this.closePopupCrop();
    },

    getListWidget() {
      const parameters = {
        limit: 100,
        page: 1,
        column: 'id',
        sort: 'asc',
      };
      this.getListWidgetDetail({ params: parameters });
    },

    showPopupChangeBanner() {
      if (!this.url_banner) {
        this.showPopupBanner();
      } else {
        const slashPosition = this.company_banner.url_banner.lastIndexOf('/') + 1;
        this.fileName = this.company_banner.url_banner.substring(slashPosition);
        this.fileUrl = this.url_banner;
      }
    },

    showPopupBanner() {
      this.$refs.modalBanner.show();
      this.showModalBanner = true;
    },

    showPopupCrop() {
      this.$refs.modalCrop.show();
      this.showModalCrop = true;
    },

    closePopupBanner() {
      this.$refs.modalBanner.hide();
      this.showModalBanner = false;
      this.showModalCrop = false;
      this.fileUrl = '';
    },

    closePopupCrop() {
      this.$refs.modalCrop.hide();
      this.showModalCrop = false;
      this.fileUrl = '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .label-required-upload {
    font-family: 'Poppins-Regular';
    font-size: 12px;
    color: #9C9B9B;
    text-align: center;
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }
  .widget-content {
    background-color: #FCFDFE;
    padding-top: 86px;

    .company-banner {
      width: 100%;
      height: 300px;
      position: relative;
      box-sizing: border-box;
      overflow: hidden;
      margin-top: -4px;

      img {
        width: 105%;
        height: 105%;
        object-fit: cover;
        position: absolute;
        top: -1%;
        left: -1%;
        filter: blur(8px);
      }
      .banner-container {
        position: relative;
        width: 100%;
        height: 100%;
        background: #0000001c;
      }
      button {
        position: absolute;
        font-family: 'Poppins-Medium';
        font-size: 12px;
        color: #1a1919;
        padding: 4px 14px;
        background-color: white;
        border-radius: 6px;
        border: none;
        border-radius: 6px;
        top: 35px;
        right: 50px;
        box-shadow: 0px 1px 4px rgba(117, 117, 117, 0.25);
      }
    }

    .content-officeless-home {
      .my-application {
        width: 100%;
        background-color: #ffffff;
        box-shadow: 0px 0px 8px rgba(146, 146, 146, 0.153273);
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 30px;

        .title {
          font-family: 'Poppins-Bold';
          font-size: 14px;
          color: #4A4A4A;
          margin-bottom: 25px;
        }
        .appliaction-list {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          grid-template-rows: repeat(2, 55px);
          grid-gap: 12px;

          .application {
            background-color: #F5F5F5;
            border-radius: 8px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/widget/jWidgetSetting.vue